import MDialog from './MDialog.vue';

export { MDialog };
export default MDialog;
